import MinimalLayout from '../layout/MinimalLayout';
import Loadable from '../ui-component/Loadable';
import { lazy } from 'react';
import NavMotion from '../layout/NavMotion';
import WidgetError from '../views/scheduling-widget/widget-wizard/WidgetError';
import config from '../config';
import EmbeddedWidget from '../views/scheduling-widget/embedded/EmbeddedWidget';
import Widget from '../views/scheduling-widget/Widget';
import ErrorCatcher from '../ui-component/error-catcher';

const AppointmentsWidget = Loadable(lazy(() => import('../views/customer-appointments-widget/AppointmentsWidget')));
const DepositRequestWidget = Loadable(lazy(() => import('../views/deposit-request-widget/DepositRequestWidget')));
const InviteAppointmentWidget = Loadable(lazy(() => import('../views/invite-widget/index')));
const PublicSelfCheckout = Loadable(lazy(() => import('../views/public-self-checkout/index')));
const AppointmentCallScreen = Loadable(lazy(() => import('../views/calls/AppointmentCall')));
const EmployeeCallScreen = Loadable(lazy(() => import('../views/calls/EmployeeCall')));
const EmployeeWidget = Loadable(lazy(() => import('../views/provider-widget/index')));
const WaitlistRescheduleWidget = Loadable(lazy(() => import('../views/waitlist-reschedule-widget')));
const AppointmentConfirmation = Loadable(lazy(() => import('../views/appointment-confirmation-view')));

const PublicRoutes = [
    {
        path: 'cal',
        element: <MinimalLayout />,
        children: [
            {
                path: config.publicPath,
                element: <WidgetError />
            },
            {
                path: `${config.publicPath}/embed/provider/:providerName/:providerId/*`,
                element: (
                    <ErrorCatcher wrappedComponentName="EmployeeWidget">
                        <EmployeeWidget />
                    </ErrorCatcher>
                )
            },
            {
                path: `${config.publicPath}provider/:providerName/:providerId/*`,
                element: (
                    <ErrorCatcher wrappedComponentName="EmployeeWidget">
                        <EmployeeWidget />
                    </ErrorCatcher>
                )
            },
            {
                path: `${config.publicPath}:company_slug/deposit-request/:appointment_uuid`,
                element: (
                    <ErrorCatcher wrappedComponentName="DepositRequestWidget">
                        <DepositRequestWidget />
                    </ErrorCatcher>
                )
            },
            {
                path: `${config.publicPath}:company_slug/invite-to-schedule/:appointment_invite_uuid`,
                element: (
                    <ErrorCatcher wrappedComponentName="InviteAppointmentWidget">
                        <InviteAppointmentWidget />
                    </ErrorCatcher>
                )
            },
            {
                path: `${config.publicPath}:company_slug/self-checkout/:appointment_uuid/*`,
                element: (
                    <ErrorCatcher wrappedComponentName="PublicSelfCheckout">
                        <PublicSelfCheckout />
                    </ErrorCatcher>
                )
            },
            {
                path: `${config.publicPath}:company_slug/*`,
                element: (
                    <NavMotion>
                        <ErrorCatcher wrappedComponentName="Widget">
                            <Widget />
                        </ErrorCatcher>
                    </NavMotion>
                )
            },
            {
                path: `${config.publicPath}/embed/:company_slug/*`,
                element: <EmbeddedWidget />
            },
            {
                path: `${config.publicPath}:company_slug/booking/:appointment_uuid`,
                element: (
                    <NavMotion>
                        <ErrorCatcher wrappedComponentName="AppointmentsWidget">
                            <AppointmentsWidget />
                        </ErrorCatcher>
                    </NavMotion>
                )
            },
            {
                path: `${config.publicPath}:company_slug/waitlist/:appointment_uuid`,
                element: (
                    <ErrorCatcher wrappedComponentName="WaitlistRescheduleWidget">
                        <WaitlistRescheduleWidget />
                    </ErrorCatcher>
                )
            },
            {
                path: `${config.publicPath}:company_slug/cbvc/:appointment_uuid`,
                element: (
                    <ErrorCatcher wrappedComponentName="AppointmentCallScreen">
                        <AppointmentCallScreen />
                    </ErrorCatcher>
                )
            },
            {
                path: `${config.publicPath}:company_slug/:employee_slug/cbvc`,
                element: (
                    <ErrorCatcher wrappedComponentName="EmployeeCallScreen">
                        <EmployeeCallScreen />
                    </ErrorCatcher>
                )
            },
            {
                path: `${config.publicPath}:company_slug/confirm/:appointment_uuid`,
                element: (
                    <ErrorCatcher wrappedComponentName="AppointmentConfirmation">
                        <AppointmentConfirmation />
                    </ErrorCatcher>
                )
            }
        ]
    }
];

export default PublicRoutes;
